import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    { key: 'CODE', label: 'code', defaultShow: true },
    { key: 'NAME', label: 'name', defaultShow: true },
    { key: 'PACKAGE_TYPES_LABEL', label: 'packageTypes', defaultShow: true },
    { key: 'RETURNABLE', label: 'returnable', defaultShow: true, type: 'select', selectOption: 'boolNumberCodes' },
    { key: 'ACTIVE', label: 'active', defaultShow: true, type: 'select', selectOption: 'boolNumberCodes' },
    { key: 'SYNCED_AT', label: 'syncedAt', defaultShow: true, type: 'dateTime' },
];
